import { render, staticRenderFns } from "@/shared/components/FlatSelectorIcon/FlatSelectorIcon.pug?vue&type=template&id=c0bbd842&scoped=true&lang=pug&external"
import script from "./FlatSelectorIcon.component.vue?vue&type=script&lang=ts"
export * from "./FlatSelectorIcon.component.vue?vue&type=script&lang=ts"
import style0 from "@/shared/components/FlatSelectorIcon/FlatSelectorIcon.scss?vue&type=style&index=0&id=c0bbd842&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0bbd842",
  null
  
)

export default component.exports